import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private http: HttpClient) {}
  getAllProduct(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/product', { params });
  }

  updateProduct(id: string, productData: any) {
    return this.http.put(`/v1/admin/product/${id}`, productData);
  }
  createProduct(productData: any) {
    return this.http.post('/v1/admin/product', productData);
  }
  getProductById(id: string) {
    return this.http.get(`/v1/admin/product/${id}`);
  }

  exportProduct(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/product/export`, filterData, options);
  }

  syncProductsByCategoryId(categoryId: number, productCategoryId: string) {
    return this.http.post<ApiResponse>(`/v1/admin/product/sync-products/${categoryId}`, { productCategoryId });
  }

  // ============== Product Category API's ============= //

  getProductCategory(filterData: IPaginationParams) {
    let httpParams = new HttpParams();
    if (filterData) {
      Object.keys(filterData).forEach((key) => {
        httpParams = httpParams.append(key, String((filterData as any)[key]));
      });
    }
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/product-categories', { params: httpParams });
  }

  createProductCategories(productCategoriesData: any) {
    return this.http.post<ApiResponse>('/v1/admin/product-categories', productCategoriesData);
  }

  updateProductCategories(id: string, productCategoriesData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/product-categories/${id}`, productCategoriesData);
  }

  getProductCategoriesById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/product-categories/${id}`);
  }

  exportCategoryProduct(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/product-categories/export`, filterData, options);
  }
  syncCategories() {
    return this.http.get<ApiResponse>(`/v1/admin/product-categories/sync-categories`);
  }
}
